export default class Location {
  constructor(data) {
    this.id = data.id || ''
    this.latitude = data.latitude
    this.longitude = data.longitude
    this.bearing = data.bearing || 0
  }
}
